import type { StudentCohortAssignmentReleased } from "../auth/api-client";

export function quizRetakeAvailable(a: StudentCohortAssignmentReleased): boolean {
  if (a.retakeAvailable != null) return a.retakeAvailable;
  return Boolean(
    a.open && !a.retakeUsed && a.attempt1Score != null && a.attempt1Score < 100
  );
}

export function quizStudentActionLabel(a: StudentCohortAssignmentReleased): string {
  return quizRetakeAvailable(a) ? "Retake quiz" : "Take quiz";
}
